import React from 'react';

function AboutOurCommitmentSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '64px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    imageCol: {
      flex: '0 0 520px',
      width: 520,
      maxWidth: '100%',
      minWidth: 0
    },
    image: {
      width: '100%',
      maxWidth: 520,
      aspectRatio: '4/3',
      objectFit: 'cover',
      display: 'block',
      opacity: 1
    },
    textCol: {
      flex: '1 1 0',
      minWidth: 260,
      maxWidth: 520,
      textAlign: 'left'
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      display: 'inline-block',
      width: 150,
      height: 0,
      borderBottom: '2px solid #E73123',
      marginLeft: 12,
      verticalAlign: 'middle',
      opacity: 1
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: '8px 0 0 0'
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: '4px 0 0 0'
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      letterSpacing: 0,
      color: '#838383',
      margin: '16px 0 0 0'
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.imageCol },
      React.createElement('img', {
        src: '/commitment.jpg',
        alt: 'Our commitment - infrastructure development',
        style: styles.image
      })
    ),
    React.createElement('div', { style: styles.textCol },
      React.createElement('h2', { style: styles.overline },
        'OUR COMMITMENT',
        React.createElement('span', { style: styles.overlineRule })
      ),
      React.createElement('h3', { style: { margin: '8px 0 0 0', textAlign: 'left' } },
        React.createElement('span', { style: styles.titleRed }, 'COMMITTED TO'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'SUSTAINABLE GROWTH'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'AND RESPONSIBLE'),
        React.createElement('br'),
        React.createElement('span', { style: styles.titleBlack }, 'PROGRESS')
      ),
      React.createElement('p', { style: styles.body },
        "We're dedicated to sustainable development, prioritizing environmental stewardship and social responsibility. With a passion for progress and a focus on excellence, we're shaping India's infrastructure landscape and there's many more miles to go!"
      )
    )
  );
}

export default AboutOurCommitmentSection;
